import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v0/auth';
const token = '3405698345tgj-0349gui34fgojw4f5290';

class AuthEndpoint extends BaseEndpoint {

    byToken(token) {
        var data = {};
        data.token = token
        const url = apiPath + '/token';
        return this.client.$post(url, data)
    }

    smsCode(data) {
        data.token = token
        const url = apiPath + '/sms-code';
        return this.client.$post(url, data)
    }

    smsCodeCheck(data) {
        const url = apiPath + '/sms-code-check';
        return this.client.$post(url, data)
    }

    emailCode(data) {
        data.token = token
        const url = apiPath + '/email-code';
        return this.client.$post(url, data)
    }

    emailCodeCheck(data) {
        const url = apiPath + '/email-code-check';
        return this.client.$post(url, data)
    }

    auth(data) {
        const url = apiPath;
        return this.client.$post(url, data)
    }

    me(cookie = null) {
        let headers = {}
        if (cookie) {
            headers.cookie = cookie
        }
        const url = apiPath + '/me';
        try {
            return this.client.$get(url, {headers: headers}).catch(err => {
                console.info(err)
                return false
            })
        } catch (e) {
            return false
        }
    }

    Logout() {
        return this.client.$delete(apiPath)
    }


    subscribe_email(email) {
        try {
            return this.client.$post(apiPath + '/subscribe_email', {
                token,
                email
            })
        } catch (e) {
            return false
        }
    }
}

export default AuthEndpoint;
